import React from 'react'

const Layers = ({ width = 24, height = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M0,0H24V24H0Z" />
    <path
      fill="#454e5b"
      d="M11.99,18.54,4.62,12.81,3,14.07l9,7,9-7L19.37,12.8ZM12,16l7.36-5.73L21,9,12,2,3,9l1.63,1.27ZM12,4.53,17.74,9,12,13.47,6.26,9Z"
    />
  </svg>
)

export default Layers
